import React from "react";
import { List } from "../../../../OrderedList";
import styled from "styled-components";
import css from "@styled-system/css";
import { Wrapper } from "../../../../Wrapper";
import { Stream, TitleGreen } from "../../styled";
import { desktop } from "../../../../../theme";
import image2 from "./image2.gif";
import image13 from "./image13.gif";
import tiktok from "./tiktok.svg";

const Image = styled("img")(
  css({
    display: ["none", "block"],
    position: "absolute",
    left: "84%",
    transform: "translateX(-50%)",
  })
);

const Image2 = styled(Image)(
  css({
    top: 400,
    maxWidth: 400,
    width: "calc(32% - 50px)",
    borderRadius: 8,
  })
);

Image2.defaultProps = {
  src: image2,
};

const Image13 = styled("img")(
  css({
    display: "block",
    mx: "auto",
    mb: 100,
    borderRadius: 8,
    position: "absolute",
    width: "calc(100% - 48px)",
    maxWidth: 400,
    top: -350,
    left: "50%",
    transform: "translateX(-50%)",
    [desktop]: {
      position: "absolute",
      left: "84%",
      top: "auto",
      bottom: 0,
      mb: 0,
      transform: "translate(-50%, 50%)",
      zIndex: 2,
      width: "calc(32% - 50px)",
    },
  })
);

Image13.defaultProps = {
  src: image13,
};

const Tiktok = styled(Image)(
  css({
    top: 0,
    transform: "translate(-50%, -50%)",
  })
);
Tiktok.defaultProps = {
  src: tiktok,
};

const Layout = styled("div")(
  css({
    width: [null, "68%"],
  })
);

const WrapperStyled = styled(Wrapper)(
  css({
    position: "relative",
    pb: [100, 60],
  })
);

const ListStyled = styled(List)(
  css({
    li: {
      my: ["10px", 27],
    },
  })
);

const TitleStyled = styled(TitleGreen)(
  css({
    mt: 0,
    mb: [15, 40],
  })
);

const StreamStyled = styled(Stream)(
  css({
    mt: [400, 0],
  })
);

export const HowToBePopular = () => (
  <StreamStyled id="how-to-be-popular">
    <WrapperStyled>
      <Tiktok />
      <Image2 />
      <Image13 />
      <TitleStyled>Как стать популярным?</TitleStyled>
      <Layout>
        <ListStyled>
          <li>
            <p>
              Первое к&nbsp;чему должны быть все готовы&nbsp;&mdash; выделить
              определенное время на&nbsp;поддержание своего аккаунта.
              В&nbsp;постинге соблюдай линию одного формата. Новые видео
              планируй по&nbsp;конкретным дням, чтобы аудитория привыкла
              к&nbsp;графику.
            </p>
          </li>
          <li>
            <p>
              Просматривай видео других пользователей, оставляй комментарии
              и&nbsp;лайки. Часто можно встретить отзывчивых пользователей,
              которые с&nbsp;удовольствием подпишутся в&nbsp;ответ,
              а&nbsp;вы&nbsp;с&nbsp;удовольствием вместе залипните
              на&nbsp;интересных аккаунтах.
            </p>
          </li>
          <li>
            <p>
              Ты&nbsp;можешь попасть в&nbsp;ТОП по&nbsp;трендовому хэштегу, если
              в&nbsp;описании своего ролика укажешь только один хэштег без
              каких-либо подписей. Его даже можно поставить на&nbsp;время
              в&nbsp;свой профиль и&nbsp;в&nbsp;название аккаунта.
            </p>
          </li>
          <li>
            <p>
              Чтобы узнать лучшее время для постинга, перейди
              на&nbsp;PRO-аккаунт (в&nbsp;настройках). В&nbsp;статистике
              посмотри время активности своих подписчиков. Пости за&nbsp;пару
              часов до&nbsp;пика, так как твоё видео ещё должно разогнаться.
            </p>
          </li>
        </ListStyled>
      </Layout>
    </WrapperStyled>
  </StreamStyled>
);
